import { Box } from '@wix/design-system';
import React from 'react';
import { DefaultRecommendations } from './DefaultRecommendations';
export const EmptyQueryStatus = () => {
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    marginTop: "SP4",
    align: "center"
  }, /*#__PURE__*/React.createElement(DefaultRecommendations, null));
};
//# sourceMappingURL=EmptyQueryStatus.js.map